// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__VqNWb","stickerOne":"styles_stickerOne__DPWS0","stickerTwo":"styles_stickerTwo__awRIv","sticky":"styles_sticky__Wqe3m"};